"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("regenerator-runtime/runtime");var _asyncToGenerator2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator"));var _objectSpread2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/objectSpread2"));







































































































var _vuex = require("vuex");
var _Breadcrumb = _interopRequireDefault(require("@/components/Breadcrumb"));
var _Hamburger = _interopRequireDefault(require("@/components/Hamburger"));
var _ErrorLog = _interopRequireDefault(require("@/components/ErrorLog"));
var _Screenfull = _interopRequireDefault(require("@/components/Screenfull"));
var _SizeSelect = _interopRequireDefault(require("@/components/SizeSelect"));
var _LangSelect = _interopRequireDefault(require("@/components/LangSelect"));
var _HeaderSearch = _interopRequireDefault(require("@/components/HeaderSearch")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { components: { Breadcrumb: _Breadcrumb.default, Hamburger: _Hamburger.default, ErrorLog: _ErrorLog.default, Screenfull: _Screenfull.default, SizeSelect: _SizeSelect.default, LangSelect: _LangSelect.default, Search: _HeaderSearch.default }, computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['sidebar', 'avatar', 'device', 'name', 'env', 'showSettings' // 将是否显示设置按钮作为是否展示全屏、搜索等功能控制开关
  ]), { currentEnv: function currentEnv() {var res = '未知';switch (process.env.VUE_APP_OG_ENV) {case 'development':res = '国内-测试';break;case 'americaDevelopment':res = '海外-测试';break;case 'production':res = '国内-生产';break;case 'asiaProduction':res = '亚洲区-生产';break;case 'americaProduction':res = '美洲区-生产';break;default:break;}console.log('currentEnv====res======>', res);return res;} }), data: function data() {var _this = this;var validatePass = function validatePass(rule, value, callback) {if (value === '') {callback(new Error('请再次输入密码'));} else if (value !== _this.addData.newPwd) {callback(new Error('两次输入密码不一致!'));} else {callback();}};return { newAdd: false, addData: { checkPwd: '', newPwd: '', oldPwd: '' }, rules: { oldPwd: [{ required: true, message: '请输入旧密码', trigger: 'blur' }], newPwd: [{ required: true, message: '请输入新密码', trigger: 'blur' }], checkPwd: [{ required: true, validator: validatePass, trigger: 'blur' }], roleId: [{ required: true, message: '请选择角色类型', trigger: 'change' }], insId: [{ required: true, message: '请选择机构名称', trigger: 'change' }] } };}, methods: { toggleSideBar: function toggleSideBar() {this.$store.dispatch('app/toggleSideBar');}, logout: function () {var _logout = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {return regeneratorRuntime.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return this.$store.dispatch('user/logout');case 2:this.$router.push("/login?redirect=".concat(this.$route.fullPath));case 3:case "end":return _context.stop();}}}, _callee, this);}));function logout() {return _logout.apply(this, arguments);}return logout;}(), handleShowPwd: function handleShowPwd() {this.newAdd = true;}, onSubmit: function onSubmit() {// 详情弹窗提交
      var self = this;self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/admin/updateMyPwd', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.closeRefund();
          });
        } else {
          return false;
        }
      });
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();
      this.newAdd = false;
    } } };exports.default = _default;